<script>
import axios from 'axios';
import API from '../services/api';
import Token from '../modules/token.js';

const api = new API();

module.exports = {
  template: '#login-template',
  data: function() {
    return {
      loading: false,
      loginError: false,
      registerError: false,
      confirmError: false,
      confirmErrorMsg: false,
      registerErrors: false,
      registerErrorCodes: {},
      confirmEmail: this.$route.name == 'getactivationlink' ? true : false,
      confirmEmailSent: false,
      terms: false,
      user: {
        username: '',
        password: '',
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        address: '',
        zip: '',
        city: '',
        password1: '',
        password2: '',
        code: ''
      },
      login: this.$route.name == 'register' || this.$route.name == 'getactivationlink' ? false : true,
      confirm: this.$route.name == 'getactivationlink' ? true : false,
      errors: {
        email: false
      }
    };
  },
  computed: {
    loggedIn: function() {
      return this.$store.state.loggedIn;
    },
    logoutStatus: function() {
      let status = this.$store.state.logoutStatus;
      this.$store.state.logoutStatus = false;
      return status;
    }
  },
  methods: {
    toggleTab: function() {
      if (this.login) {
        this.login = false;
        this.confirmEmail = false;
        //this.confirm = false;
      } else this.login = true;
    },
    facebookLogin: function() {
      let self = this;

      function verifyUser(response) {
        let request = response;

        FB.api('/me?fields=email', function(response) {
          if (!response.error) {
            request.email = response.email;
            request.type = 'facebook';

            api.verifyUser(request).then(result => {
              if (result.status == 1) {
                self.$store.dispatch('init');
                self.$store.commit('setLoggedIn', true);
                self.error = false;
                window.scrollTo(0, 1);
              }
            });
          }
        });
      }

      FB.getLoginStatus(function(response) {
        //console.log('fb login');
        //console.log(response);
        if (response.status == 'connected') verifyUser(response.authResponse);
        else {
          FB.login(
            function(response) {
              verifyUser(response.authResponse);
            },
            { scope: 'public_profile,email' }
          );
        }
      });
    },
    onSubmit: function() {
      let self = this;

      self.loading = true;

      Token.getToken(token => {
        axios
          .post('/ajax/login/?cm_lang=fi_FI', {
            username: self.user.username,
            password: self.user.password,
            token: token
          })
          .then(response => {
            //console.log({ response: response });
            self.loading = false;

            if (response.data.success) {
              if (/koeajoraportti/.test(location.href)) {
                location.reload();
              } else {
                this.$store.dispatch('init');
                this.$store.commit('setLoggedIn', true);
                self.error = false;
                window.scrollTo(0, 1);
                dataLayer.push({
                  UserLoggedIn: true
                });
              }
            }
          })
          .catch(error => {
            //console.log({ error: error });

            self.loading = false;
            self.loginError = {
              msg: typeof error.response.data.error.msg !== 'undefined' ? error.response.data.error.msg : true
            };
          });
      });
    },
    onSubmitRegister: function() {
      let self = this;
      self.loading = true;
      self.registerError = false;
      self.errors.email = false;

      for (let key in self.user) {
        if (key != 'code' && key != 'username' && key != 'password') {
          let el = self.user[key];
          if (el == '') {
            self.registerError = true;
          }
        }
      }
      if (self.user['password1'] !== self.user['password2']) self.registerError = true;

      if (!self.terms) self.registerError = true;

      if (!self.registerError)
        api.registerUser(self.user).then(res => {
          if (res.status == 1) {
            self.confirm = true;
            window.scrollTo(0, 1);
          }
          // User already exists
          else if (res.status == -20) {
            self.registerErrors = true;
            self.registerErrorCodes = {
              'title': 'Virhe: Käyttäjätunnus on jo olemassa.',
              'code': res.status,
              'msg': res.msg
            }
            self.errors.email = true;
          }
          // Not a Laakkonen client
          else if (res.status == 2) {
            self.registerErrors = true;
            self.registerErrorCodes = {
              'title': 'Virhe: Rekisteröinti ei onnistunut.',
              'code': res.status,
              'msg': res.msg
            }
          }
          // User was not found from posti API
          else if (res.status == -19) {
            self.registerErrors = true;
            self.registerErrorCodes = {
              'title': 'Virhe: Rekisteröinti ei onnistunut.',
              'code': res.status,
              'msg': res.msg
            }
          }
          // Too many users was found in posti API (more than 1)
          else if (res.status == -30) {
            self.registerErrors = true;
            self.registerErrorCodes = {
              'title': 'Virhe:',
              'code': res.status,
              'msg': res.msg
            }
          }
          // Universal error message
          else {
            self.registerErrors = true;
            self.registerErrorCodes = {
              'title': 'Virhe: rekisteröinti ei onnistunut.',
              'code': res.status,
              'msg': ''
            }
          }

          self.loading = false;
        });

      if (self.registerError) self.loading = false;
    },
    getConfirmationEmail: function() {
      let self = this;

      self.loading = true;

      self.confirmError = false;
      self.confirmErrorMsg = false;

      if (self.user.email)
        api
          .getActivationLinkEmail({
            email: self.user.email
          })
          .then(res => {
            if (res.status == 1) {
              self.confirmEmailSent = true;
              self.confirmError = false;
            } else {
              self.confirmErrorMsg = 'Käyttäjätunnusta ei löytynyt.';
            }
            self.loading = false;
          });
      else {
        self.loading = false;
        self.confirmError = true;
      }
    },
    onSubmitConfirm: function() {
      let self = this;

      self.loading = true;

      self.confirmError = false;

      if (self.user.code)
        api
          .confirmUser({
            email: self.user.email,
            code: self.user.code
          })
          .then(res => {
            if (res.token) {
              Token.getToken(token => {
                axios
                  .post('/ajax/login/?cm_lang=fi_FI', {
                    username: self.user.email,
                    password: self.user.password1,
                    token: token
                  })
                  .then(response => {
                    //console.log({ response: response });

                    if (response.data.success) {
                      if (/koeajoraportti/.test(location.href)) location.reload();
                      else {
                        this.$store.dispatch('init');
                        this.$store.commit('setLoggedIn', true);
                        self.error = false;
                        window.scrollTo(0, 1);
                      }
                    }

                    self.loading = false;
                  })
                  .catch(error => {
                    //console.log({ error: error });

                    self.error = typeof error.response.data.error !== 'undefined' ? error.response.data.error : true;
                  });
              });
            } else self.confirmError = true;
          });
      else self.confirmError = true;

      self.loading = false;
    }
  }
};
</script>
